import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import apiMethod from "../../../services/api-service";
import { useParams } from "react-router-dom";
import methods from "../../../services/utility";
import { toast } from "react-toastify";

const AddAddressModal = ({
  show,
  onHide,
  merchantInfo,
  setLoading,
  getAdress,
}) => {
  const { branchId } = useParams();
  const [shipmentsInfo, setShipmentsInfo] = useState({
    branchId,
    title: "",
    size: 200,
    part: 1,
  });
  const [shipments, setShipments] = useState([]);
  const [createAddressInfo, setCreateAddressInfo] = useState({
    id: 0,
    title: "",
    address: "",
    phone: "",
    zipCode: "",
    faxNumber: "",
    cityId: null,
    userId: 0,
    shipmentId: null,
  });

  const getShipments = async () => {
    const resp = await apiMethod.getShipmentCosts(
      shipmentsInfo.branchId,
      shipmentsInfo.title,
      shipmentsInfo.size,
      shipmentsInfo.part
    );
    if (methods.showApiErrors(resp)) {
      setShipments(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      await getShipments();
    };
    bindData();
  }, [branchId]);

  useEffect(() => {
    if (merchantInfo?.userId) {
      setCreateAddressInfo((prev) => ({
        ...prev,
        userId: merchantInfo.userId,
      }));
    }
  }, [merchantInfo]);

  const handleSaveAddress = async () => {
    if (!createAddressInfo.title || !createAddressInfo.address) {
      toast.error("لطفاً تمام فیلدهای ضروری را پر کنید.");
      return;
    }
    setLoading(true);
    const resp = await apiMethod.createAddress(createAddressInfo);
    if (methods.showApiErrors(resp)) {
      toast.success("آدرس با موفقیت اضافه شد...");
    }
    setLoading(false);
    await getAdress();
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton>
        <span className="fw-bold">اضافه کردن آدرس</span>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <div className="col-12 mb-3">
            <label htmlFor="location" className="form-label">
              انتخاب محل
            </label>
            <select
              className="form-select"
              aria-label="Default select example"
              value={createAddressInfo?.shipmentId}
              onChange={(e) => {
                const value = e.target.value;
                setCreateAddressInfo({
                  ...createAddressInfo,
                  shipmentId: value === "" ? null : Number(value),
                });
              }}
            >
              <option value={""}>محل آدرس</option>
              {shipments.map((shipment, sindx) => (
                <option key={sindx} value={shipment.id}>
                  {shipment.areaTitle} -{" "}
                  {methods.addNumSeperator(shipment.price)}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 mb-3">
            <label htmlFor="title" className="form-label">
              عنوان آدرس
            </label>
            <input
              type="text"
              id="title"
              placeholder="عنوان 
              آدرس را وارد نمایید"
              className="form-control"
              value={createAddressInfo?.title}
              onChange={(e) =>
                setCreateAddressInfo({
                  ...createAddressInfo,
                  title: e.target.value,
                })
              }
            />
          </div>
          <div className="col-12 mb-3">
            <label htmlFor="address" className="form-label">
              آدرس
            </label>
            <textarea
              placeholder="آدرس را وارد نمایید"
              rows={4}
              className="form-control"
              value={createAddressInfo?.address}
              onChange={(e) =>
                setCreateAddressInfo({
                  ...createAddressInfo,
                  address: e.target.value,
                })
              }
            ></textarea>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
          <button
            type="button"
            className="btn custome-btn btn-link-purple"
            onClick={onHide}
          >
            انصراف
          </button>
          <button
            type="button"
            className="btn custome-btn btn-purple"
            onClick={handleSaveAddress}
          >
            ثبت و ذخیره
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddAddressModal;
